import React from "react";

export default function Gallery() {
  const images = [
    "/images/fort.jpg",
    "/images/fort2.jpg",
    "/images/fort3.jpg",
    "/images/garden.jpg",
    "/images/garden2.jpg",
    "/images/gate.jpg",
    "/images/vijay.jpg",
  ];

  const styles = {
    container: {
      padding: "20px",
      textAlign: "center",
      marginTop: "20px",
    },
    heading: {
      fontSize: "28px",
      fontWeight: "bold",
      marginBottom: "20px",
      color: "#4A148C",
      textTransform: "uppercase",
      letterSpacing: "1px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "20px",
      padding: "10px",
    },
    card: {
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
      border: "3px solid #4A148C",
      transition: "0.3s",
    },
    img: {
      width: "100%",
      height: "250px",
      objectFit: "cover",
      display: "block",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>📸 पर्यटन गॅलरी - बल्लारपूर</h2>

      <div style={styles.grid}>
        {images.map((src, index) => (
          <div
            key={index}
            style={{
              ...styles.card,
              transform: "scale(1)",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.05)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.transform = "scale(1)")
            }
          >
            <img src={src} alt="gallery" style={styles.img} />
          </div>
        ))}
      </div>
    </div>
  );
}
